import inview from './inview';
import mattressSelector from './../../../inc/modules/mattress/assets/mattress-selector';
import swiperimages from './swiper-images';

export default {
  init() {
    inview.init();
    swiperimages.init();
    mattressSelector.init();
    this.megaMenu();
    this.smoothScroll();
    this.stickyMenu();
    this.homepageBanner();

    $(document).on('change', '#wpsl-search-input', function() {
      setTimeout(function() {
        $('#wpsl-search-btn').trigger('click');
      }, 500);
    });

    // Toggle tab for hot spots
    $(document).on('click', '.e-hotspot', function() {
      const _this = $(this);
      setTimeout(function() {
        const labels = _this.find('.e-hotspot__label').text().split(' ');

        $('.dialog-widget:visible .info-tab .nav-link').each(function() {
          if ($(this).text().toUpperCase().trim() === labels[1].toUpperCase().trim()) {
            $(this).tab('show');
          }
        });
      }, 200);
    });

    // Toggle tab for info tabs
    $(document).on('click', '[data-tab-target]', function() {
      const _this = $(this);
      setTimeout(function() {
        $($('.dialog-widget:visible .info-tab .nav-link')[_this.data('tab-target')]).tab('show');
      }, 200);
    });
  },

  onWindowEvents: function(foo, isReady, isLoad, isResize, isScroll) {
    if (isReady) {
      $(document).ready(foo);
    }

    if (isLoad) {
      $(window).bind('load', foo);
    }

    if (isResize) {
      const throttleResizing = _.throttle(foo, 100);
      $(window).bind('resize', throttleResizing);
    }

    if (isScroll) {
      const throttleScroll = _.throttle(foo, 10);
      $(window).bind('scroll', throttleScroll);
    }
  },

  homepageBanner() {
    $('.action a').click(function() {
      $('.action a').removeClass('active');
      $(this).addClass('active');
    });
  },

  stickyMenu() {
    const body = $('body');
    this.onWindowEvents(function(event) {
      if (window.pageYOffset > Sealy.scrollThreshold) {
        if (!body.hasClass('header--sticky--shown')) {
          body.addClass('header--sticky--shown');
        }
      } else {
        if (body.hasClass('header--sticky--shown')) {
          body.removeClass('header--sticky--shown');
        }
      }
    }, 1, 1, 1, 1);
  },

  megaMenu() {
    // Header menu item hover
    setTimeout(function() {
      // Wait for max mega menu to load first
      $('.custom-mega > ul.mega-sub-menu li.mega-menu-item').hoverIntent({
        over: function() {
          $(this).addClass('hover');
        },
        out: function() {
          $(this).removeClass('hover');
        },
        timeout: 200
      });

      $('li.mega-menu-item.custom-mega').on('open_panel', function() {
        $('body').addClass('mega-menu-hover');
      }).on('close_panel', function() {
        $('body').removeClass('mega-menu-hover mega-menu--force-hide');
      });
    }, 500);
  },

  smoothScroll() {
    $('.scroll-to')
      // Remove links that don't actually link to anything
      .not('[href="#"]').not('.nav-item').not('[href="#0"]').click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
        &&
        location.hostname === this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 80
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(':focus')) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          });
        }
      }
    });
  },
};
